import type { AppRouteModule } from '/@/router/types';
import { LAYOUT2 } from '/@/router/constant';
import { t } from '@mcex/locale';
import { PageEnum } from '/@/enums/pageEnum';
import { useMetfStoreWithOut } from '/@/store/modules/metf';
import { DefaultMetfCode } from '/@/api/const';
import { getFeatureStateByName, initFeaturesConfig } from '/@/utils/featureToggle';
const metf: AppRouteModule = {
  path: PageEnum.METF,
  name: 'METF',
  component: LAYOUT2,
  redirect: PageEnum.METF_DETAIL + `/${DefaultMetfCode}`, // FIXME：暂时写死
  meta: {
    title: t('routes.metf.home'),
    // 开关控制此模块是否可访问
    feature: 'metf',
  },
  beforeEnter: async (to, from, next) => {
    try {
      await initFeaturesConfig();
    } catch (error) {}
    if (!getFeatureStateByName('metf')) {
      next({ path: PageEnum.FORBIDDEN_PAGE, replace: true });
    }
    next();
  },
  children: [
    {
      path: 'detail/:productCode',
      name: 'METF',
      component: () => import('/@/views/metf/index.vue'),
      props: (route) => ({ productCode: route.params.productCode }),
      meta: {
        title: t('routes.metf.home'),
      },
      beforeEnter: async (to) => {
        const metfStore = useMetfStoreWithOut();
        metfStore.fetchLastNetValue(to.params.productCode as string);
        return true;
      },
    },
  ],
};

export default metf;
